import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import cn from "classnames";
import * as ScrollMagic from "scrollmagic";
import {
  ScrollMagicPluginIndicator,
  ScrollMagicPluginGsap,
} from "scrollmagic-plugins";
import { TweenMax, TimelineMax } from "gsap";


import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import MagicContainer from "../../components/magicContainer";

import FsSwiper from "../fsSwiper";
import InterestingFacts from "../interestingFacts";
import CoverOne from "../coverOne";
import TimelineHorizontally from "../timelineHorizontally";
import One from "../../milestones/one"
import Header from "../header";
import Footer from "../footer";

import "../firstScreen/firstScreen.scss";


function FirstScreen(props) {
  const { setSection, scroll, setCurrentDate, anchor  } = props;

  


  const width = window.innerWidth;


  

  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  const [progress, setProgress] = useState(0);
  const [selfs, setSelfs] = useState(null); 
  // const [currentScroll, setCurrentScroll] = useState(0);


  let  tl;

  useEffect(() => {
    

        window.scrollTo({
      top: scroll,

  });
  },[scroll])


  useEffect(()=> {


   

    // function getScrollLookup(targets, containerAnimation, position) {
    //   let triggers = gsap.utils.toArray(targets).map(section => ScrollTrigger.create({
    //         trigger: section,
    //         start: position || "left left",
    //         containerAnimation: containerAnimation
    //       })),
    //       st = containerAnimation.scrollTrigger;
    //   return target => {
    //     let t = gsap.utils.toArray(target)[0],
    //         i = triggers.length;
    //     while (i-- && triggers[i].trigger !== t) {};
    //     return i >= 0 ? st.start + (triggers[i].start / containerAnimation.duration()) * (st.end - st.start) : console.warn("target not found", target);
    //   };
    // }


const setEndSection = (status) => {

}
    // var offset= document.querySelector(".timeline-horizontally__item--month-6").offsetTop;
    // 
    // if (window.innerWidth > 767) {
       tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".first-screen",
          // start: "",
          // end: "bottom to
          scrub: true,
          pin: true,
          end: "+=" +3300,
          onEnter: (self) => {
           
            // setTimeout(() => {
            //   setSelfs(self);
            // },2800)
            // self.kill()

// self.scroll(2200);
   
            // if (scroll) {
            //   
              self.scroll(scroll);
            // }
            
          },
                onLeave: (self) => {
        
        // ", self.scroll());

        setTimeout(() => {
          self.kill()
          setSection({"section": "firstScreen", status: false})
        }, 800)

        // ScrollTrigger.disable();
        // let list = document.querySelector(".timeline-horizontally__container");
        // list.classList.add("_active");
        // 
;
      },
            onEnterBack: (self) => {
        

      },
      onLeaveBack: (self) => {
        
      },
              // onToggle: (self) => self.scroll(2200),
        }
      })
      .to(".first-screen__slider", 0,   {className: "first-screen__slider first-screen__slider--hide"}, 0)
      .to(".first-screen__slider", 0,   {className: "first-screen__slider first-screen__slider--active"}, 0)
      .to(".first-screen__slider", 100, {className: "first-screen__slider first-screen__slider--hide"}, 800)
      .to(".interesting-facts", 100, {className: "interesting-facts first-screen__interesting-facts first-screen__interesting-facts--show"}, 800)
      .to(".interesting-facts__content", 100, {className: "interesting-facts__content interesting-facts__content--show"}, 800)
      .to(".interesting-facts", 100, {className: "interesting-facts first-screen__interesting-facts first-screen__interesting-facts--hide"}, 2200)
      .to(".first-screen__content", 100, {className: "first-screen__content first-screen__content--active"}, 2200)
      .to(".first-screen", 100, {className: "first-screen first-screen--cover"}, 2200)
      .to(".cover", 100, {className: "cover cover--show cover--1 timeline__cover"}, 2200)
      .to(".cover", 100, {className: "cover cover--hide cover--1 timeline__cover"}, 3300)
      // .to(".timeline-horizontally", 100, {className: "timeline-horizontally timeline-horizontally--show timeline__timeline-horizontally"}, 3000)
      .to(".first-screen", 0,   {className: "first-screen first-screen--cover first-screen--hide"}, 3300)
      // .to(".first-screen", 0,   {className: "first-screen first-screen--cover first-screen--hide"}, 3300)
      // .to(".first-screen", 0,   {opacity: 0}, 3300)
      // .call(, 2500)
      // .to(".first-screen", 0,   {className: "first-screen first-screen--cover first-screen--hide"}, 4000,
      //  )

      
      // var getPosition = getScrollLookup(".section", tl, "left left");
    // }

    // gsap.to(window, {
    //   scrollTo: getPosition(".timeline-horizontally__item--month-6"),
    //   overwrite: "auto",
    //   duration: 1
    // });

    
    setSelfs(tl.scrollTrigger);
  },[])

  useEffect(()=>{
 
    if (anchor && anchor.years !== null && anchor.years !== 1) {
      
      
      selfs.kill();
      // setSection({"section": "firstScreen", status: false})

    }
  },[anchor, selfs])


  // document.querySelector(".timeline-horizontally__list").offsetWidth
  return (
    <>
      {/* <MagicContainer
        controller={controller}
        duration={ll}
        trigger=".first-screen"
        pin=".first-screen"
        animate={animate}
      >
        {({ progress }) => ( */}

          <section className="first-screen page__first-screen">
                  <div className={cn("hide-load")}>
        <img src="img/three/three-load.png" alt="" />
        <img src="img/three/two-load.png" alt="" />
      </div>
            <div className="first-screen__container">
              <div className="first-screen__header">
                <Header components="fs"  setCurrentDate={setCurrentDate}/>
              </div>
              <div className="first-screen__content">
                {/* <MagicContainer
                  controller={controller}
                  duration={1000}
                  trigger=".first-screen"
                  pin=".first-screen__slider"
                  animate={animate}
                >
                  {({ progress }) => ( */}
                    <div className="first-screen__slider">
                      <FsSwiper />
                    </div>
                  {/* )}
                </MagicContainer> */}
                <InterestingFacts progress={progress} />
                <CoverOne progress={progress} />
                {/* <One /> */}
                
              </div>
              <div className="first-screen__footer">
                <Footer />
              </div>
            </div>
          </section>
        {/* )} */}
      {/* </MagicContainer> */}
    </>
  );
}

export default FirstScreen;
